export default function increaseProductImage() {
    const productVisualContainer = $('.product-gallery-holder');
    const pagination = productVisualContainer.find('.product-gallery-pagination');
    const galleryBody = productVisualContainer.find(".product-gallery");

    productVisualContainer.append('<div class="increased-img"></div>');
    const addedImgContainer = productVisualContainer.find('.increased-img');
    let picture;
    
    let setImgProps = function () {
        picture = galleryBody.find('.swiper-slide.swiper-slide-active picture').clone();
        
        if(picture) {
            addedImgContainer.html(picture);
        } else {
            addedImgContainer.find("picture").remove();
        }
    };

    setImgProps();

    productVisualContainer.on('mouseover', '.product-gallery', function() {
        if(picture.length) {
            addedImgContainer.addClass('show');
        }
    });

    productVisualContainer.on('mouseleave', '.product-gallery', function() {
        addedImgContainer.removeClass('show');
    });

    let timer;
    pagination.on('click', '.swiper-slide', function() {
        clearTimeout(timer);
        timer = setTimeout(() => {
            setImgProps();
        }, 100);
    });
}